<template>
  <div class="m-page m-p1">
    <h2>Tell us a little about yourself</h2>
    <p>Select the status that matches the closest to your current situation</p>
    <div class="m-page__flex">
      <div class="m-page__filing" :class="{'m-page__filing--error' : showErrorMessage}">
        <RadioCard v-model="filingStatus" :label="'Single'" value="single" @change="updateFilingStatus">
          <svg class="icon-single" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 39.8 51.3">
            <g>
              <path fill="#CFE6F0" d="M8.8,13.7c2.7-1.2,4.6-5,7.4-3.2c4.4,2.9,10,3.2,14.8,0.9c0,0-1.9-10.7-12.1-10.7 S8.8,13.7,8.8,13.7z" transform="translate(.009)"/>
              <g>
                <path fill="#CFE6F0" d="M1,19.3c-0.3,0-0.6-0.3-0.7-0.7c-0.1-0.3-1.7-6.7,2.7-9c2-1,2.7-2.6,1.5-8.6 C4.5,0.6,4.8,0.1,5.2,0c0,0,0.1,0,0.1,0c0.5-0.1,0.9,0.2,1,0.7c0,0,0,0,0,0c1,5.3,0.9,8.7-2.5,10.6c-3.2,1.7-1.8,6.8-1.8,6.9 c0.1,0.5-0.2,0.9-0.6,1.1L1,19.3z" transform="translate(1.871 17.251)"/>
              </g>
              <g>
                <path fill="#4F5661" d="M3.8,3.5c-1.5,0-2.9-0.8-3.7-2.1c-0.2-0.4-0.1-1,0.3-1.2c0.4-0.2,1-0.1,1.2,0.3l0,0 c0.7,1.2,2.3,1.6,3.5,0.9c0.4-0.2,0.7-0.5,0.9-0.9C6.3,0,6.9-0.1,7.3,0.1c0.4,0.2,0.6,0.8,0.3,1.2C6.8,2.6,5.3,3.4,3.8,3.5z" transform="translate(16.129 19.626)"/>
              </g>
              <g fill="#4F5661">
                <path d="M39.7 39l-2.7-3.7c-1.5-2.2-3.9-3.6-6.6-3.7h-4.4v-4.9c.4-.3.8-.7 1.2-1 2.4-2 3.8-5 3.9-8.1v-3.1c0-.5-.4-.9-.9-.9-.5 0-.9.4-.9.9v3.1c0 5.3-5.8 9.7-9.4 9.7s-9.4-4.4-9.4-9.7v-3.1c0-.4-.3-.8-.8-.9 0 0-.1 0-.1 0-.4 0-.8.3-.9.8 0 0 0 .1 0 .1v3.1c.2 3.7 2.1 7.1 5.1 9.1v4.9H9.5c-2.7.1-5.1 1.5-6.6 3.7L.2 39C0 39.3 0 39.6.1 39.9c6.4 10.9 20.4 14.6 31.3 8.3 3.4-2 6.3-4.8 8.3-8.3C39.8 39.6 39.8 39.3 39.7 39zM19.9 29.1c1.5-.1 3-.5 4.3-1.2v5.2c0 2.4-2.7 5.4-4.3 6.8-1.5-1.4-4.3-4.4-4.3-6.8v-5.2C17 28.6 18.4 29 19.9 29.1zM19.9 49.6c-7.4 0-14.2-3.8-18-10.1l2.4-3.2c1.2-1.8 3.1-2.9 5.2-3h4.4c.2 3.9 5.2 8.2 5.4 8.4.1.1.3.2.5.2.2 0 .4-.1.5-.2.3-.2 5.2-4.4 5.4-8.4h4.4c2.1.1 4.1 1.2 5.2 3l2.4 3.2C34 45.8 27.2 49.6 19.9 49.6L19.9 49.6zM8.8 12.8c.4 0 .8-.3.9-.8 0 0 0-.1 0-.1 0-5.7 4.6-10.3 10.3-10.3S30.2 6.3 30.2 12c0 .5.4.9.9.9.5 0 .9-.4.9-.9 0 0 0 0 0 0 0-6.6-5.4-12-12-12S8 5.4 8 12C7.9 12.4 8.3 12.8 8.8 12.8 8.7 12.8 8.8 12.8 8.8 12.8z"/>
              </g>
              <path fill="#53C27C" d="M9.7 19.7H8.5c-1.7 0-3.1-1.4-3.1-3.1 0 0 0 0 0 0v-2.4c0-1.7 1.4-3.1 3.1-3.1 0 0 0 0 0 0h1.2c.4 0 .8.3.9.8 0 0 0 .1 0 .1v6.8C10.5 19.3 10.1 19.7 9.7 19.7zM30.2 11.1h1.2c1.7 0 3.1 1.4 3.1 3.1 0 0 0 0 0 0v2.4c0 1.7-1.4 3.1-3.1 3.1 0 0 0 0 0 0h-1.2c-.4 0-.8-.3-.9-.8 0 0 0-.1 0-.1V12C29.3 11.5 29.6 11.1 30.2 11.1 30.1 11.1 30.1 11.1 30.2 11.1z" transform="translate(.009)"/>
            </g>
          </svg>
        </RadioCard>
        <RadioCard v-model="filingStatus" :label="'Married <br>(filling jointly)'" value="married" @change="updateFilingStatus">
          <svg class="icon-married" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 49.1 49.1">
            <g>
              <g>
                <path fill="#CFE6F0" d="M1.7,3.4c0,0,2.5-0.3,3.3-2L2,0L0,1.6L1.7,3.4z" transform="translate(22.079 42.114)"/>
              </g>
              <g>
                <path fill="#CFE6F0" d="M1,4.9c1.2-0.9,2.5-1.6,3.9-2L2.9,0L0,2L1,4.9z" transform="translate(26.659 20.362)"/>
              </g>
              <path fill="#FF8979" d="M23.9,7.8l-3.8-2.9c-0.1-0.1-0.3-0.1-0.5-0.2h-6.5c-0.2,0-0.3,0.1-0.5,0.2L8.9,7.8 C8.7,8,8.6,8.2,8.6,8.5c0,0.3,0.1,0.5,0.3,0.7l6.1,4.4c0.1,0.1,0.3,0.1,0.5,0.2h1.9c0.2,0,0.3-0.1,0.5-0.2l6.1-4.4 c0.2-0.1,0.3-0.4,0.3-0.7C24.2,8.2,24.1,8,23.9,7.8z" transform="translate(.082 .133)"/>
              <path fill="#4F5661" d="M32.7,16.1c-1.6,0-3.3,0.2-4.8,0.7c-6.4-6.4-16.7-6.4-23.1,0s-6.4,16.7,0,23.1 c3.1,3.1,7.2,4.8,11.6,4.8c1.6,0,3.3-0.2,4.8-0.7c6.4,6.4,16.7,6.4,23.1,0s6.4-16.7,0-23.1C41.2,17.9,37,16.1,32.7,16.1z M1.6,28.4 c0-8.1,6.6-14.7,14.7-14.7c3.6,0,7.1,1.4,9.8,3.8c-0.5,0.2-1.1,0.5-1.6,0.8c-5.6-4.6-13.8-3.7-18.4,1.9S2.5,34.1,8.1,38.6 c2.3,1.9,5.3,2.9,8.3,2.9c1,0,2.1-0.1,3.1-0.4c1.2-0.3,2.3-0.7,3.3-1.3c6.2-3.5,8.5-11.4,5-17.7c0.5-0.2,1-0.4,1.6-0.6 c3.6,6.8,1.3,15.3-5.2,19.4c-0.9,0.6-1.9,1-2.9,1.4c-1.5,0.5-3.1,0.8-4.7,0.8C8.2,43.1,1.7,36.5,1.6,28.4z M23.2,19.3 c-4.3,3.1-6.8,8-6.8,13.2c0,2.5,0.6,5,1.7,7.2c-0.6,0.1-1.1,0.1-1.7,0.2c-6.3,0-11.5-5-11.5-11.4S10,17,16.3,17 C18.8,16.9,21.2,17.8,23.2,19.3z M26.4,22.9c0.9,1.7,1.4,3.6,1.4,5.5c0,3.8-1.9,7.4-5.2,9.6c-0.9-1.7-1.4-3.6-1.4-5.5 C21.3,28.6,23.2,25.1,26.4,22.9L26.4,22.9z M31.1,21.2c0.6-0.1,1.1-0.1,1.7-0.2c6.3,0,11.5,5.1,11.5,11.4S39.1,44,32.8,44 c-2.5,0-4.8-0.8-6.8-2.3c4.3-3.1,6.8-8,6.8-13.2C32.7,25.9,32.1,23.5,31.1,21.2L31.1,21.2z M32.7,47.2c-3.6,0-7.1-1.4-9.8-3.8 c0.5-0.2,1.1-0.5,1.5-0.8c5.6,4.6,13.8,3.7,18.4-1.9s3.7-13.8-1.9-18.4c-2.3-1.9-5.3-2.9-8.3-2.9c-1,0-2.1,0.1-3.1,0.4 c-1.2,0.3-2.3,0.7-3.3,1.3c-6.2,3.5-8.5,11.4-5,17.7c-0.5,0.2-1,0.4-1.6,0.6C16.2,32.5,18.4,24,25,19.9c0.9-0.6,1.9-1,2.9-1.4 c1.5-0.5,3.1-0.8,4.7-0.8c8.2,0,14.8,6.6,14.8,14.8S40.9,47.2,32.7,47.2L32.7,47.2z" transform="translate(.082 .133)"/>
              <g>
                <path fill="#CFE6F0" d="M3.2,0.3l0.4,1.2c0.1,0.2,0.2,0.2,0.2,0.2l1.3,0.6c0.2,0.1,0.3,0.3,0.3,0.5c0,0,0,0,0,0 c0,0.1-0.1,0.2-0.2,0.2c0,0,0,0-0.1,0L4,3.6C3.8,3.7,3.7,3.8,3.7,3.9L3.2,5.2C3.1,5.4,2.9,5.5,2.7,5.4c0,0,0,0,0,0 c-0.2,0-0.3-0.1-0.3-0.2L1.8,4C1.7,3.8,1.7,3.7,1.6,3.7L0.3,3.1C0.1,3.1-0.1,2.8,0,2.6c0,0,0,0,0,0c0-0.1,0.1-0.2,0.2-0.2 c0,0,0,0,0.1,0l1.3-0.5c0.2-0.1,0.2-0.2,0.2-0.2l0.5-1.3C2.4,0.1,2.6-0.1,2.9,0c0,0,0,0,0,0C3.1,0,3.1,0.1,3.2,0.3z" transform="translate(22.212 .133)"/>
              </g>
              <g>
                <path fill="#CFE6F0" d="M3.1,0.4l0.4,1.2c0.1,0.1,0.2,0.2,0.2,0.2l1.2,0.4c0.2,0.1,0.3,0.3,0.3,0.5c0,0,0,0,0,0 C5.1,2.9,5,3.1,4.9,3.1L3.7,3.5C3.6,3.5,3.5,3.6,3.5,3.7L3,4.9C2.9,5.2,2.6,5.3,2.4,5.2c-0.1,0-0.2-0.1-0.2-0.2L1.7,3.7 C1.7,3.6,1.6,3.5,1.5,3.5L0.3,3C0.1,2.9-0.1,2.7,0,2.4c0,0,0,0,0,0c0.1-0.1,0.2-0.2,0.2-0.2l1.2-0.4c0.2-0.1,0.2-0.2,0.2-0.2 l0.5-1.2C2.3,0.1,2.6-0.1,2.8,0c0,0,0,0,0,0C3,0.1,3.1,0.2,3.1,0.4z" transform="translate(4.876 .624)"/>
              </g>
              <g transform="translate(14.801 .736)">
                <circle fill="#CFE6F0" cx="1.5" cy="1.5" r="1.5"/>
              </g>
              <g transform="translate(3.353 7.278)">
                <circle fill="#CFE6F0" cx="1.1" cy="1.1" r="1.1"/>
              </g>
              <g transform="translate(27.067 6.051)">
                <circle fill="#CFE6F0" cx="1.2" cy="1.2" r="1.2"/>
              </g>
            </g>
            <path fill="none" d="M0 0H49.1V49.1H0z"/>
          </svg>
        </RadioCard>

        <RadioCard v-model="filingStatus" label="Head of Household" value="head of house" @change="updateFilingStatus">
          <svg class="icon-headofhouse" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 50.5 51">
            <g>
              <path fill="#CFE6F0" d="M49.7,50.2H24.7l1.9-5.1c1-2.8,3.7-4.7,6.7-4.7h0.8v1c0.6,1.7,2.5,2.5,4.2,1.9 c0.9-0.3,1.6-1,1.9-1.9v-1h0.8c3,0,5.7,1.9,6.7,4.7L49.7,50.2z" transform="translate(.009)"/>
              <path fill="#FF8979" d="M22.5,44.2H0.8l1.6-4.4c0.9-2.4,3.2-4.1,5.8-4.1H9v1.2c0.7,1.5,2.5,2,4,1.3 c0.6-0.3,1-0.7,1.3-1.3v-1.2H15c2.6,0,4.9,1.6,5.8,4.1L22.5,44.2z" transform="translate(.009)"/>
              <path fill="#CFE6F0" d="M17,8.5c1.7-0.7,2.7-3.1,4.4-1.9c2.6,1.7,6,2,8.8,0.6c0,0-1.1-6.4-7.1-6.4S17,8.5,17,8.5z" transform="translate(.009)"/>
              <g>
                <path fill="#4F5661" d="M5.4,1.7H0.9C0.4,1.7,0,1.3,0,0.8C0,0.4,0.4,0,0.9,0h4.6c0.5,0,0.9,0.4,0.9,0.8 C6.3,1.3,5.9,1.7,5.4,1.7z" transform="translate(18.29 29.762)"/>
              </g>
              <path fill="#CFE6F0" d="M6.5,27.1c1.3-0.6,2.1-2.4,3.4-1.4c2,1.3,4.6,1.5,6.8,0.4c0,0-0.9-4.9-5.5-4.9 S6.5,27.1,6.5,27.1z" transform="translate(.009)"/>
              <path fill="#FF8979" d="M47.4,27.2c2.6-3.4-1.6-5.4-4.4-5.4c-2.9,0-0.9-4-5.7-4s-2.8,3-6.6,4s-0.9,4-3.8,6 c-2.9,2-0.9,6,2.8,7h1.8c-0.2-0.6-0.3-1.3-0.3-2v-2.5c0-0.3,0-0.6,0.1-0.8c2.4-0.6,4.6-2.1,6-4.2c1.4,2.1,3.6,3.7,6,4.3 c0,0.3,0.1,0.6,0.1,0.8V33c0,0.7-0.1,1.3-0.3,2h1C51.5,34.9,45.6,29.6,47.4,27.2z" transform="translate(.009)"/>
              <g fill="#4F5661">
                <path d="M50.4 49.9l-1.9-5.1c-1.1-3.2-4.1-5.3-7.5-5.3l0 0v-1.8c1.8-1.3 2.9-3.3 3-5.5v-2.4c0-.5-.4-.8-.8-.8l0 0c-.5 0-.8.4-.8.8v2.3c0 2.9-3.2 5.4-5.2 5.4S32 35 32 32.1v-2.3c0-.4-.3-.8-.7-.8 0 0-.1 0-.1 0-.5 0-.8.4-.8.8v2.4c.1 2.2 1.2 4.2 3 5.5v1.8l0 0c-3.4 0-6.3 2.1-7.5 5.3l-1.9 5.1c-.1.3-.1.5.1.8.2.2.4.4.7.3h24.9c.3 0 .5-.1.7-.3C50.5 50.4 50.6 50.2 50.4 49.9zM37.3 39.3c.8 0 1.5-.2 2.2-.5v2.4c-.5 1.2-1.8 1.8-3 1.4-.6-.2-1.1-.7-1.4-1.4v-2.4C35.7 39.1 36.5 39.3 37.3 39.3zM25.9 49.3l1.4-4c.9-2.5 3.2-4.1 5.9-4.2v.3l.1.2c.1.2.2.4.3.6l0 0c0 0 0 .1.1.1 0 0 0 0 0 0 .7 1.2 2 1.9 3.4 2 1.4 0 2.7-.8 3.4-2l.1-.1 0 0c.1-.2.2-.4.3-.6l.1-.2v-.3l0 0c2.7 0 5 1.7 5.9 4.2l1.5 4H25.9zM21.8 39.5c-1-2.7-3.6-4.6-6.5-4.6v-1.4c1.3-1 2.3-2.5 2.6-4.2 0-.3.1-.5.1-.7v-2c0-3.4-2.7-6.1-6.1-6.1s-6.1 2.7-6.1 6.1v2c.1 1.9 1.1 3.7 2.6 4.8v1.4c-2.9 0-5.6 1.9-6.5 4.7L.1 44C0 44.2 0 44.5.2 44.7c.2.2.4.3.7.3h21.7c.3 0 .5-.1.7-.3.2-.2.2-.5.1-.8L21.8 39.5zM7.3 28.6v-2l0 0c0-2.4 2-4.4 4.4-4.4s4.4 2 4.4 4.4v2.6c-.5 2.2-2.2 3.8-4.4 4.1C10 33.2 7.3 31 7.3 28.6zM11.7 34.9c.6 0 1.2-.2 1.8-.4v2.3c-.4.6-1.1 1-1.8 1-.7 0-1.4-.4-1.8-1v-2.3C10.5 34.7 11.1 34.8 11.7 34.9L11.7 34.9zM2 43.4L3.2 40C4 38 6 36.6 8.2 36.6v.6l.1.2c1 1.9 3.3 2.6 5.2 1.6.7-.4 1.2-.9 1.6-1.6l.1-.2v-.6c2.2 0 4.2 1.4 4.9 3.5l1.2 3.3L2 43.4zM27.8 20.4h.3c.8 0 1.6.2 2.4.4.1 0 .2.1.3.1.4 0 .7-.3.8-.6.2-.4-.1-.9-.5-1.1-.9-.3-1.9-.5-2.9-.5h-.2v-2.2c2-1.4 3.3-3.7 3.4-6.2V7.7c0-4.2-3.4-7.7-7.7-7.7S16 3.4 16 7.7c0 0 0 0 0 0v2.6c.1 2.5 1.4 4.8 3.4 6.2v2.2h-.2c-1.1 0-2.3.2-3.3.7-.4.1-.6.6-.5 1 0 0 0 .1 0 .1.1.3.4.5.8.5.1 0 .2 0 .3-.1.8-.3 1.7-.5 2.6-.5h.3c1.2 2.3 4 3.2 6.3 2C26.7 22 27.4 21.3 27.8 20.4zM17.6 10.3V7.7l0 0c.1-3.3 2.8-5.9 6.1-5.8 3.2.1 5.7 2.6 5.8 5.8v2.6c0 3.4-3.7 6.2-6 6.2S17.6 13.7 17.6 10.3L17.6 10.3zM23.7 21.3c-1 0-2-.5-2.6-1.4v-2.3c.8.4 1.7.6 2.6.7.9 0 1.8-.3 2.6-.7v2.3C25.7 20.7 24.7 21.3 23.7 21.3L23.7 21.3z"/>
              </g>
            </g>
          </svg>
          <el-popover
            slot="popover"
            placement="top"
            width="194"
            trigger="click">
            <slot>If you are single with a dependent you can claim Head of Household.</slot>
            <el-button class="override-helpbtn" slot="reference" circle>
              <svg class="override-helpbtn-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 5.8 8.8">
                <path fill="#FFF" d="M5.8,2.4C5.8,0.7,4.4,0,3,0C1.5-0.1,0.1,1,0,2.6c0,0,0,0,0,0l1.9,0.2c0-0.6,0.4-1.1,1-1.1	c0,0,0,0,0,0c0.4,0,0.8,0.3,0.9,0.7c0,0,0,0.1,0,0.1c0,0.3-0.2,0.7-0.5,0.9L2.9,3.8C2.3,4.2,2,4.8,2,5.6V6h1.9V5.7	C3.9,5.2,4,5,4.5,4.6C5.3,4.2,5.8,3.3,5.8,2.4z M4.1,7.7c0-0.6-0.5-1.1-1.2-1.1C2.3,6.5,1.8,7,1.7,7.7c0,0.6,0.5,1.2,1.1,1.2	c0,0,0.1,0,0.1,0C3.6,8.9,4.1,8.4,4.1,7.7C4.1,7.7,4.1,7.7,4.1,7.7L4.1,7.7z"/>
              </svg>
            </el-button>
          </el-popover>
        </RadioCard>
        <transition name="fade">
          <div v-if="showErrorMessage" class="validation-message-1">Please select a filing status.</div>
        </transition>
      </div>

      <div class="m-page__options">
        <CheckboxCard v-model="filingStatusOptions.age65" label="65+" value="65+" @change="updateFilingStatusOptions('age65', filingStatusOptions.age65)">
          <svg class="icon-65plus" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 43.3 57.3">
            <g transform="translate(.034 -.17)">
              <path fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M8.4 25.9c0 0-4.5-1.8-5.2-5.2s3.1-4.7 3.5-5.8S6.3 10 7.6 8.6s3.8-1.4 5.2-2.2 6-5.1 8-5.2 3.6-.3 5.3 1.8 3.4 4.3 6 4.3c2.7 0 5.8 1.5 5.3 4.3s-1.7 3.1-.6 5.2 3.4 4.6 1.1 7c-.8.8-1.5 1.6-2.2 2.4M18.6 26.8c.9 1.7 3.1 2.4 4.8 1.5.6-.3 1-.8 1.4-1.3M27.1 27.1c0 0 .3.9 2.1 1.1"/>
              <g>
                <path fill="#CFE6F0" d="M40.8,7.6c-6.6,11.2-21,15-32.2,8.5C5,14,2.1,11,0,7.5l3.9-4c1.6-2,4-3.3,6.5-3.5h3.7l4,6.9 c0.8,1.3,2.4,1.7,3.8,1c0.4-0.2,0.7-0.6,1-1l4-6.9h3.7c2.5,0.3,4.9,1.5,6.4,3.5L40.8,7.6z" transform="translate(1.1 36.872)"/>
              </g>
              <path fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M16.3,27.1 c0,0-0.3,0.9-2.1,1.1"/>
              <circle fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" cx="18" cy="22.7" r="2"/>
              <circle fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" cx="24.8" cy="22.7" r="2"/>
              <path fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M20.6 22.7c.5-.3 1.2-.3 1.7 0M24.4 34.1c0 0-5.8.9-9.1-.9-2.7-1.4-4.4-4.1-4.5-7.1-.2-2.4.2-8.7.2-8.7s2 .6 3.8-1.8c5.2 3.4 11.8 3.8 17.4 1.1.4 4.7.6 8.3.3 10.5-.3 2.2-3.1 4.7-4 5.3.1 1.5.1 3 .1 4.5 0 0-4.4 6.9-5.2 8-.9 1-2.6.7-3.4-.5s-4.3-6.6-4.3-6.6"/>
              <path fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M11.5,37.2 c-1.6,0.2-3.2,0.8-4.6,1.6c-2.1,1.4-5.7,5.8-5.7,5.8c1.2,1.9,2.6,3.7,4.1,5.2c2.3,2.1,9.4,6.6,16.9,6.6s13.4-4.6,14.9-5.9 c1.8-1.9,3.4-3.9,4.9-5.9c-1.7-2-3.6-3.9-5.5-5.7c-1.4-1-3.1-1.6-4.8-1.8"/>
            </g>
          </svg>
          <el-popover
            slot="popover"
            placement="top"
            width="194"
            trigger="click">
            <slot>For tax year 2022, increase the standard deduction by $1,750 if you file single or head of household. Increase it by $1,400 if you are married filing jointly and you or your spouse are 65+, increase it by $2,800 if you are both 65+.</slot>
            <el-button class="override-helpbtn" slot="reference" circle>
              <svg class="override-helpbtn-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 5.8 8.8">
                <path fill="#FFF" d="M5.8,2.4C5.8,0.7,4.4,0,3,0C1.5-0.1,0.1,1,0,2.6c0,0,0,0,0,0l1.9,0.2c0-0.6,0.4-1.1,1-1.1	c0,0,0,0,0,0c0.4,0,0.8,0.3,0.9,0.7c0,0,0,0.1,0,0.1c0,0.3-0.2,0.7-0.5,0.9L2.9,3.8C2.3,4.2,2,4.8,2,5.6V6h1.9V5.7	C3.9,5.2,4,5,4.5,4.6C5.3,4.2,5.8,3.3,5.8,2.4z M4.1,7.7c0-0.6-0.5-1.1-1.2-1.1C2.3,6.5,1.8,7,1.7,7.7c0,0.6,0.5,1.2,1.1,1.2	c0,0,0.1,0,0.1,0C3.6,8.9,4.1,8.4,4.1,7.7C4.1,7.7,4.1,7.7,4.1,7.7L4.1,7.7z"/>
              </svg>
            </el-button>
          </el-popover>
        </CheckboxCard>

        <CheckboxCard v-model="filingStatusOptions.blind" label="Legally Blind" value="blind" @change="updateFilingStatusOptions('blind')">
          <svg class="icon-blind" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 48.7 60.3">
            <g>
              <path transform="rotate(-22.317 15.746 11.833)" fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M12.8 4.3H19.1V19.6H12.8z"/>
              <path transform="rotate(-22.317 27.865 41.214)" fill="#FF8979" d="M26.6 32.2H29.400000000000002V50.6H26.6z"/>
              <path transform="rotate(-22.317 26.074 36.688)" fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M24.3 17.7H28.1V56H24.3z"/>
              <path fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M13,8.9 c0,0-1.2-1.1-3.2,0.8S4.6,14,2,10s0.8-9.6,4.7-8.8C9,1.7,11.1,3,12.4,5" transform="translate(.042 -.076)"/>
              <path fill="none" stroke="#CFE6F0" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M38.7 53.7L43 47.5M41.4 55.1L43.7 53.2" transform="translate(.042 -.076)"/>
              <path fill="none" stroke="#4F5661" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M23.9 59.3L47.7 59.3" transform="translate(.042 -.076)"/>
            </g>
          </svg>
          <el-popover
            slot="popover"
            placement="top"
            width="194"
            trigger="click">
            <slot>For tax year 2022, increase the standard deduction by $1,750 if you file single or head of household. Increase it by $1,400 if you are married filing jointly and you or your spouse are blind, increase it by $2,800 if you are both blind.</slot>
            <el-button class="override-helpbtn" slot="reference" circle>
              <svg class="override-helpbtn-icon" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" viewBox="0 0 5.8 8.8">
                <path fill="#FFF" d="M5.8,2.4C5.8,0.7,4.4,0,3,0C1.5-0.1,0.1,1,0,2.6c0,0,0,0,0,0l1.9,0.2c0-0.6,0.4-1.1,1-1.1	c0,0,0,0,0,0c0.4,0,0.8,0.3,0.9,0.7c0,0,0,0.1,0,0.1c0,0.3-0.2,0.7-0.5,0.9L2.9,3.8C2.3,4.2,2,4.8,2,5.6V6h1.9V5.7	C3.9,5.2,4,5,4.5,4.6C5.3,4.2,5.8,3.3,5.8,2.4z M4.1,7.7c0-0.6-0.5-1.1-1.2-1.1C2.3,6.5,1.8,7,1.7,7.7c0,0.6,0.5,1.2,1.1,1.2	c0,0,0.1,0,0.1,0C3.6,8.9,4.1,8.4,4.1,7.7C4.1,7.7,4.1,7.7,4.1,7.7L4.1,7.7z"/>
              </svg>
            </el-button>
          </el-popover>
        </CheckboxCard>
        <div class="m-page__additional">Additional options</div>
        <p class="m-page__additionalp">Calculations are based on one spouse being either 65+ or blind and not both</p>
      </div>
    </div>
  </div>
</template>

<script>
import RadioCard from '@/components/RadioCard'
import CheckboxCard from '@/components/CheckboxCard'

import { Notification } from 'element-ui'

export default {
  name: 'Page1',
  components: {
    RadioCard,
    CheckboxCard
  },
  props: ['showErrorMessage'],
  data () {
    return {
      filingStatus: this.$store.state.filingStatus,
      filingStatusOptions: {
        age65: this.$store.state.filingStatusOptions.age65,
        blind: this.$store.state.filingStatusOptions.blind
      }
    }
  },
  methods: {
    updateFilingStatus (payload) {
      this.$emit('validated', this.$store.state.indexUI)
      this.$store.commit('SET_VALID', '1')
      this.$store.commit('SET_FILING_STATUS', payload)
    },
    updateFilingStatusOptions (key, value) {
      let payload = {
        key: key,
        value: value
      }
      this.$store.commit('SET_FILING_STATUS_OPTIONS', payload)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import '../scss/vars';
  .m-p1 {
    .validation-message-1 {
      font-family: $fPrimary;
      font-size: 14px;
      font-weight: $fMed;
      background: $cError;
      color: $cWhite;
      position: absolute;
      bottom: -40px;
      left: 0;
      right: 0;
      padding: 10px;
      border-radius: 4px;
      @media (max-width: $sm) {
        position: relative;
        bottom: inherit;
      }
    }
  }
  .m-page {
    &__flex {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      width: 100%;
      @media (max-width: $sm) {
        flex-flow: column;
      }
    }
    &__filing {
      display: flex;
      flex-flow: row;
      width: 60%;
      justify-content: space-around;
      align-self: start;
      padding-top: 12px;
      padding-bottom: 12px;
      position: relative;
      @media (max-width: $sm) {
        width: 100%;
        flex-flow: column;
      }
      &--error {

      }
    }
    &__options {
      display: flex;
      flex-flow: row wrap;
      background: rgba(6, 182, 201, .1);
      padding-top: 12px;
      padding-bottom: 12px;
      width: 40%;
      justify-content: space-around;
      border-radius: 6px;
      @media (max-width: $sm) {
        flex-flow: column;
        width: 100%;
      }
    }
    &__additional {
      width: 100%;
      text-align: center;
      margin-top: 17px;
      color: $cTeal;
      font-family: $fPrimary;
      font-size: 12px;
      line-height: 16px;
    }
    &__additionalp {
      font-family: $fPrimary;
      font-size: 10px;
      line-height: 1.2;
      margin: 8px auto 0;
      max-width: 200px;
    }
  }

  .icon-single {
    width: 40px;
    height: 51px;
    @media (max-width: $sm) {
      width: 28px;
      height: 35.7px;
    }
  }
  .icon-married {
    width: 49px;
    height: 49px;
    @media (max-width: $sm) {
      width: 29.4px;
      height: 29.4px;
    }
  }
  .icon-headofhouse {
    width: 51px;
    height: 51px;
    @media (max-width: $sm) {
      width: 35.7px;
      height: 35.7px;
    }
  }
  .icon-65plus {
    width: 43px;
    height: 57px;
    @media (max-width: $sm) {
      width: 30.1px;
      height: 39.9px;
    }
  }
  .icon-blind {
    width: 49px;
    height: 60px;
    @media (max-width: $sm) {
      width: 34.3px;
      height: 42px;
    }
  }
</style>
